import { createContext } from "react";
import type React from "react";

import type { UpsertAWSAccountDiscoveryInput } from "app/mutations/__generated__/UpsertAWSAccountDiscoveryMutation.graphql";

interface OnboardingContext {
  orgDetails: UpsertAWSAccountDiscoveryInput | null;
  setOrgDetails: React.Dispatch<
    React.SetStateAction<UpsertAWSAccountDiscoveryInput | null>
  >;
}

export const OnboardingContext = createContext<OnboardingContext>({
  orgDetails: null,
  setOrgDetails: () => {
    // do nothing
  },
});
